<template>
  <div class="sales-commission-page">
    <el-form class="search-form" :model="searchForm" inline size="small">
      <el-form-item label="商品编码">
        <el-input v-model="searchForm.condition.artNo" clearable placeholder="请输入商品编码" />
      </el-form-item>
      <el-form-item label="是否有特殊提成方案">
        <el-select v-model="searchForm.condition.hasSpecialCommission" clearable placeholder="不限">
          <el-option label="不限" value="" />
          <el-option label="是" value="1" />
          <el-option label="否" value="0" />
        </el-select>
      </el-form-item>
      <el-form-item label="是否献方商品">
        <el-select v-model="searchForm.condition.hasReferralCommission" clearable placeholder="不限">
          <el-option label="不限" value="" />
          <el-option label="是" value="1" />
          <el-option label="否" value="0" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
      <el-form-item class="right-actions">
        <el-button type="primary" plain @click="openAddDialog">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table class="commission-table" :data="tableData" border height="280" :cell-style="{ borderColor: '#dcdfe6' }"
      :header-cell-style="{ background: '#f5f7fa', borderColor: '#dcdfe6', color: '#333333' }">
      <el-table-column prop="artNo" label="商品编码" min-width="130" />
      <el-table-column prop="productName" label="商品名称" min-width="160" />
      <el-table-column prop="commissionRate" label="通用提成比例" min-width="150" />
      <el-table-column prop="hasSpecialCommission" label="是否有特殊提成比例" width="170">
        <template slot-scope="scope">
          <span>{{ scope.row.hasSpecialCommission === 1 ? '是' : '否' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="hasReferralCommission" label="是否献方商品" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.hasReferralCommission === 1 ? '是' : '否' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleDelete(scope.row)">删除</el-button>
          <el-button size="mini" type="primary" @click="openEditDialog(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="page-wrap">
      <el-pagination background layout="sizes,total, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 40]"
        :page-size="searchForm.pageSize" :current-page="searchForm.pageIndex" :total="total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="commissionDialogVisible" width="950px" top="5vh">
      <el-form ref="commissionForm" :model="commissionForm" :rules="rules" label-width="120px" size="small">
        <div class="form-section-title">商品信息</div>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="商品货号" prop="artNo">
              <el-input v-model="commissionForm.artNo" placeholder="请输入货号" @input="artNoInput" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品名称" prop="productName">
              <el-input disabled v-model="commissionForm.productName"  />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="提成属性" prop="commissionCategoryName">
              <el-input disabled v-model="commissionForm.commissionCategoryName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="通用提成比例" prop="commissionRate">
              <el-input disabled v-model="commissionForm.commissionRate">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="form-section-title">
          <span>特殊提成方案</span>
          <el-tooltip placement="left" popper-class="commission-rule-tooltip">
            <div slot="content" class="commission-rule-tooltip__content">
              <div>1. 工作室全体成员：指该工作室的所有人销售该商品，都是按该特殊比例提成</div>
              <div>2. 指定医生：该医生销售该商品，按该特殊比例提成</div>
              <div>3. 工作室销售带头人提成：团队成员销售时，带头人额外提成</div>
            </div>
            <span class="section-help-icon">?</span>
          </el-tooltip>
        </div>
        <el-form-item label="是否有特殊提成方案" label-width="150px" prop="hasSpecialCommission">
          <el-radio-group v-model="commissionForm.hasSpecialCommission" @input="handleSpecialSpecialCommissionChange">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="commissionForm.hasSpecialCommission == 1">
          <div class="special-plan-row" v-for="(item, index) in commissionForm.specialCommissionRules" :key="index">
            <div class="plan-item">
              <el-form-item label="特殊提成对象" label-width="110px" :prop="`specialCommissionRules.${index}.type`"
                :rules="specialRules.type">
                <el-select v-model="item.type" placeholder="请选择" style="width: 190px;">
                  <el-option label="工作室全体成员" :value="1" />
                  <el-option label="指定医生" :value="2" />
                  <el-option label="工作室销售带头人提成" :value="3" />
                </el-select>
              </el-form-item>
            </div>
            <div class="plan-item" v-if="item.type == 1">
              <el-form-item label="工作室名称" label-width="100px" :prop="`specialCommissionRules.${index}.teamId`"
                :rules="specialRules.teamId">
                <el-select v-model="item.teamId" filterable placeholder="请选择工作室" style="width: 150px;" @change="handleSpecialTeamIdChange(index,$event)">
                  <el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id"/>
                </el-select>
              </el-form-item>
            </div>
            <div class="plan-item" v-if="item.type == 2">
              <el-form-item label="医生姓名" label-width="100px" :prop="`specialCommissionRules.${index}.doctorName`"
                :rules="specialRules.doctorName" >
                <el-select v-model="item.doctorName" filterable placeholder="请选择医生" style="width: 150px;" remote
                  :remote-method="getDoctorList" @change="handleSpecialDoctorNameChange(index,$event)">
                  <el-option v-for="item in doctorList" :key="item.doctorId" :label="item.nickName"
                    :value="item.doctorId" />
                </el-select>
              </el-form-item>
            </div>
            <div class="plan-item" v-if="item.type == 3">
              <el-form-item label="工作室名称" label-width="100px" :prop="`specialCommissionRules.${index}.teamId`"
                :rules="specialRules.teamId">
                <el-select v-model="item.teamId" filterable placeholder="请选择工作室" style="width: 150px;" @change="handleSpecialTeamIdChange(index,$event)">
                  <el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
            </div>
            <div class="plan-item">
              <el-form-item label="提成比例" label-width="80px" :prop="`specialCommissionRules.${index}.commissionRate`"
                :rules="specialRules.commissionRate">
                <el-input v-model="item.commissionRate" placeholder="请输入0-100" style="width: 170px;">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </div>
            <div class="plan-item plan-item-delete">
              <el-button type="text" size="small" @click="handleRemoveSpecialPlan(index)">删除</el-button>
            </div>
          </div>
          <el-form-item label=" ">
            <el-button type="primary" plain size="small" @click="handleAddSpecialPlan">添加特殊方案</el-button>
          </el-form-item>
        </div>
        <div class="form-section-title">
          <span>献方提成</span>
          <el-tooltip placement="left" popper-class="commission-rule-tooltip">
            <div slot="content" class="commission-rule-tooltip__content">
              献方提成：全平台所有人（包括所属医生本人）销售该产品，献方所属医生都会额外提成
            </div>
            <span class="section-help-icon">?</span>
          </el-tooltip>
        </div>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label="是否献方商品" prop="hasReferralCommission">
              <el-radio-group v-model="commissionForm.hasReferralCommission">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <template v-if="commissionForm.hasReferralCommission == 1">
            <el-col :span="12">
              <el-form-item label="所属医生" prop="referralCommissionRule.doctorName"
                :rules="[{ required: true, message: '请选择所属医生', trigger: 'change' }]">
                <el-select v-model="commissionForm.referralCommissionRule.doctorName" placeholder="请选择" filterable remote :remote-method="getDoctorList" @change="handleReferralDoctorNameChange">
                  <el-option v-for="item in doctorList" :key="item.doctorId" :label="item.nickName"
                    :value="item.doctorId" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="献方提成比例" prop="referralCommissionRule.commissionRate"
                :rules="[{ required: true, message: '请输入献方提成比例', trigger: 'blur' }]">
                <el-input v-model="commissionForm.referralCommissionRule.commissionRate" placeholder="请输入0-100">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </el-col>
          </template>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="commissionDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getDoctorList } from '@/api/operation';
import { salaryCommissionPage, salaryCommissionSave, salaryCommissionDelete, salaryCommissionDetail, salaryCommissionUpdate } from '@/api/salary'
import { debounce,isNull } from '@/utils/validateBase';
import {getDrugCommission} from '@/api/drug'
import { getTeamList } from '@/api/studio';
const getEmptyCommissionForm = () => ({
  artNo: '',
  productName: '',
  commissionCategoryName: '',
  commissionRate: '',
  hasSpecialCommission: 0,
  specialCommissionRules: [],
  hasReferralCommission: 0,
  referralCommissionRule: {
    doctorId: '',
    doctorName: '',
    commissionRate: ''
  }
});
export default {
  name: 'SalesCommission',
  data() {
    return {
      total: 1,
      editIndex: -1,
      commissionDialogVisible: false,
      searchForm: {
        condition: {
          artNo: '',
          hasSpecialCommission: null,
          hasReferralCommission: ''
        },
        pageIndex: 1,
        pageSize: 10
      },
      commissionForm: getEmptyCommissionForm(),
      rules: {
        artNo: [{ required: true, message: '请输入商品货号', trigger: 'blur' }],
        hasSpecialCommission: [{ required: true, message: '请选择是否有特殊提成方案', trigger: 'change' }],
        hasReferralCommission: [{ required: true, message: '请选择是否成为商品', trigger: 'change' }],
        productName: [{ required: true, message: '请选择商品名称', trigger: 'change' }],
        commissionCategoryName: [{ required: true, message: '请选择提成属性', trigger: 'change' },{ validator: (rule, value, callback) => {
          if(['A类','B类','C类','D类','F类','T类'].includes(value)) {
            callback();
          } else {
            callback(new Error('仅限针对ABCDTF类商品设置特殊提成方案'));
          }
        }, trigger: 'blur' }],
        commissionRate: [{ required: true, message: '请输入通用提成比例', trigger: 'change' }]
      },
      tableData: [],
      doctorList: [],
      teamList:[]
    };
  },
  computed: {
    dialogTitle() {
      return this.editIndex > -1 ? '编辑销售特殊零售提成' : '新增销售特殊零售提成';
    },
    specialRules() {
      return {
        type: [{ required: true, message: '请选择特殊提成对象', trigger: 'change' }],
        teamId: [{ required: true, message: '请选择工作室名称', trigger: 'change' }],
        doctorName: [{ required: true, message: '请选择医生姓名', trigger: 'change' }],
        commissionRate: [
          { required: true, message: '请输入提成比例', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const num = parseFloat(value);
              // 提成比例必须大于0且小于等于100 的整数
              if (num < 0 || num > 100 || !Number.isInteger(num)) {
                callback(new Error('提成比例必须大于0且小于等于100 的整数'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      };
    },
  },
  mounted() {
    this.getSalaryCommissionPage();
    this.getTeamList();
  },
  methods: {
    handleSpecialTeamIdChange(index,val) {
      this.commissionForm.specialCommissionRules[index].teamName = this.teamList.find(item => item.id == val).name || '';
    },
    getTeamList(){
      getTeamList({}).then(res => {
        if(res.code == 200) {
          this.teamList = res.rows || [];
        }
      })
    },
    getDoctorList: debounce(async function (val) {
      const { code, data } = await getDoctorList({ searchKey: val });
      if (code === 200) {
        this.doctorList = data || [];
      }
    }, 300),
    handleSearch() {
      this.searchForm.pageIndex = 1;
      this.getSalaryCommissionPage();
    },
    // 删除特殊提成方案
    handleRemoveSpecialPlan(index) {
      this.commissionForm.specialCommissionRules.splice(index, 1);
    },
    handleSpecialSpecialCommissionChange(val) {
      if (val === '1' && this.commissionForm.specialCommissionRules.length === 0) {
        this.commissionForm.specialCommissionRules.push({
          type: '',
          teamId: '',
          doctorId: '',
          commissionRate: ''
        });
      }
    },
    // 分页查询销售特殊零售提成
    async getSalaryCommissionPage() {
      const { code, data } = await salaryCommissionPage(this.searchForm);
      if (code == 200) {
        this.tableData = data.records || [];
        this.total = (data && data.total) || 0;
      }
    },
    handleReset() {
      this.searchForm = {
        condition: {
          artNo: '',
          hasSpecialCommission: '',
          hasReferralCommission: ''
        },
        pageIndex: 1,
        pageSize: 10
      };
      this.getSalaryCommissionPage();
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.searchForm.pageIndex = 1;
      this.getSalaryCommissionPage();
    },
    handleCurrentChange(pageIndex) {
      this.searchForm.pageIndex = pageIndex;
      this.getSalaryCommissionPage();
    },
    openAddDialog() {
      this.editIndex = -1;
      this.commissionForm = getEmptyCommissionForm();
      this.commissionDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.commissionForm && this.$refs.commissionForm.clearValidate();
      });
    },
    openEditDialog(row) {
      this.editIndex = this.tableData.indexOf(row);
      salaryCommissionDetail({id: row.id}).then(res => {
        if (res.code === 200) {
          this.commissionForm = res.data || getEmptyCommissionForm();
          if(this.commissionForm.hasSpecialCommission == 1) {
            this.commissionForm.specialCommissionRules.forEach(item => {
               if(item.doctorId && item.doctorName) {
                this.doctorList.push({
                  doctorId: item.doctorId,
                  nickName: item.doctorName
                })
               }
            });
          }
          if(this.commissionForm.hasReferralCommission == 1) {
            if(this.commissionForm.referralCommissionRule.doctorId && this.commissionForm.referralCommissionRule.doctorName && this.doctorList.findIndex(item => item.doctorId == this.commissionForm.referralCommissionRule.doctorId) == -1) {
              this.doctorList.push({
                doctorId: this.commissionForm.referralCommissionRule.doctorId,
                nickName: this.commissionForm.referralCommissionRule.doctorName
              })
            }
          }
          this.commissionDialogVisible = true;
          this.$nextTick(() => {
            this.$refs.commissionForm && this.$refs.commissionForm.clearValidate();
          });
        }
      });
    },
    handleAddSpecialPlan() {
      this.commissionForm.specialCommissionRules.push({
        type: '',
        teamId: '',
        teamName: '',
        doctorId: '',
        doctorName: '',
        commissionRate: ''
      });
    },
    handleSave() {
      this.$refs.commissionForm.validate(valid => {
        if (!valid) return;
        const row = this.buildTableRow(this.commissionForm);
        if (this.editIndex > -1) {
          this.$set(this.tableData, this.editIndex, row);
          salaryCommissionUpdate(row).then(res => {
            if (res.code === 200) {
              this.$message.success('保存成功');
              this.commissionDialogVisible = false;
              this.getSalaryCommissionPage();
            }
          });
        } else {
          salaryCommissionSave(row).then(res => {
            if (res.code === 200) {
              this.$message.success('保存成功');
              this.commissionDialogVisible = false;
              this.getSalaryCommissionPage();
            }
          });
        }
      });
    },
    handleDelete(row) {
      this.$confirm('确认删除该商品提成配置？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const index = this.tableData.indexOf(row);
        if (index > -1) {
          salaryCommissionDelete({id: row.id}).then(res => {
            if (res.code === 200) {
              this.$message.success('删除成功');
              this.getSalaryCommissionPage();
            }
          });
        }
      }).catch(() => { });
    },
    buildTableRow(form) {
      if(form.hasSpecialCommission == 1) {
        form.specialCommissionRules.forEach(item => {
          if(item.type == '1' || item.type == '3') {
              item.doctorName = ''
          }else if(item.type == '2') {
            item.teamId = ''
            item.teamName = ''
          }
        });
      }else{
        form.specialCommissionRules = [];
      }
      return form;
    },
    handleReferralDoctorNameChange(val) {
      this.commissionForm.referralCommissionRule.doctorId = val;
      this.commissionForm.referralCommissionRule.doctorName = this.doctorList.find(item => item.doctorId == val).nickName || '';
      this.doctorList = []
    },
    handleSpecialDoctorNameChange(index,val) {
      this.commissionForm.specialCommissionRules[index].doctorId = val;
      this.commissionForm.specialCommissionRules[index].doctorName = this.doctorList.find(item => item.doctorId == val).nickName || '';
      this.doctorList = []
    },
    artNoInput:debounce(function(val){
      if(isNull(val)) return;
      getDrugCommission({artNo:val}).then(res=>{
        if(res.code == 200 && !isNull(res.data)){
          this.commissionForm.productName = res.data.drugKindName
          this.commissionForm.commissionCategoryName = res.data.commissionCategoryName
          this.commissionForm.commissionRate = res.data.commissionRate || 0
        }else{
          this.$message.error('未获到取商品信息')
          this.commissionForm.productName = ''
          this.commissionForm.commissionCategoryName = ''
          this.commissionForm.commissionRate = ''
        }
      })
    },300)
  }
};
</script>

<style lang="less" scoped>
.sales-commission-page {
  height: 100%;
  padding: 16px;
  background: #ffffff;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .search-form {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-bottom: 12px;

    /deep/ .el-form-item {
      margin-bottom: 12px;
    }

    .right-actions {
      margin-left: auto;
    }
  }

  .commission-table {
    width: 100%;
  }

  .page-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
  }

  .bottom-area {
    display: grid;
    grid-template-columns: 520px 1fr;
    gap: 16px;
    margin-top: 18px;
  }

  .preview-card,
  .rule-doc-card {
    border: 1px solid #ebeef5;
    background: #ffffff;
  }

  .preview-title {
    height: 40px;
    padding: 0 14px;
    line-height: 40px;
    font-weight: 600;
    border-bottom: 1px solid #ebeef5;
  }

  .preview-content {
    padding: 14px;
  }

  .note-text {
    margin-bottom: 12px;
    color: #606266;
    line-height: 22px;
  }

  .form-section-title {
    position: relative;
    margin: 8px 0 14px;
    padding-left: 10px;
    display: flex;
    align-items: center;
    font-weight: 600;
    color: #333333;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 14px;
      background: #0b67c8;
      border-radius: 2px;
    }

    .section-help-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      margin-left: 4px;
      border-radius: 50%;
      background: #9aa3ad;
      color: #ffffff;
      font-size: 12px;
      line-height: 16px;
      cursor: pointer;
    }
  }

  .special-plan-row {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    margin-bottom: 20px;
  }

  .plan-item {
    display: inline-flex;
    align-items: center;
    margin-right: 16px;

    .el-form-item {
      margin-bottom: 0;
    }
  }

  .plan-item-delete {
    margin-right: 0;
  }

  /deep/ .el-select,
  /deep/ .el-date-editor {
    width: 100%;
  }
}
</style>

<style lang="less">
.commission-rule-tooltip.el-tooltip__popper {
  max-width: 220px;
  padding: 10px 12px;
  border-radius: 0;
  background: #626b76;
  color: #ffffff;
  line-height: 20px;
  font-size: 12px;
  font-weight: 600;
}

.commission-rule-tooltip.el-tooltip__popper[x-placement^="left"] .popper__arrow {
  border-left-color: #626b76;
}

.commission-rule-tooltip.el-tooltip__popper[x-placement^="left"] .popper__arrow::after {
  border-left-color: #626b76;
}

.commission-rule-tooltip__content {
  white-space: normal;
}
</style>